import React from 'react';
import { DefaultContainer, AnimationContainer } from './Icons-styled';

interface StandardIconProps {
  selected?: boolean;
}

const StandardIcon: React.FC<StandardIconProps> = ({ selected = false }) => {
  const svg = (
    <svg
      style={{
        fill: selected ? '#48e2cb' : '#cacaca',
        maxHeight: '64px',
        maxWidth: '64px',
        marginBottom: '2rem'
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <path d="M.416 23.998a.83.83 0 0 1 .477-.674L23.097 10l.003-.002a1.904 1.904 0 0 1 1.802.003l22.205 13.324a.716.716 0 0 1 0 1.35L24.902 37.999a1.904 1.904 0 0 1-1.802.003L23.097 38 .893 24.676a.83.83 0 0 1-.477-.678zM46.678 24L24.452 10.663a.97.97 0 0 0-.906 0L1.321 24l22.225 13.337a.97.97 0 0 0 .906 0z"></path>
    </svg>
  );

  return selected ? (
    <AnimationContainer>{svg}</AnimationContainer>
  ) : (
    <DefaultContainer>{svg}</DefaultContainer>
  );
};

export default StandardIcon;
